import React, { useEffect } from "react";
import { FlexContainer, LottieLoadingIndicator, Toast } from "src/components";
import { ActionButton, TextLabel } from "./style";
import { SOCIAL_MEDIAS } from "../constants";
import Facebook from "src/img/emailCampaigns/facebook.svg";
import Instagram from "src/img/emailCampaigns/instagram.svg";
import X from "src/img/emailCampaigns/x.svg";
import Linkedin from "src/img/emailCampaigns/linkedin.svg";
import YouTube from "src/img/emailCampaigns/youTube.svg";
import Web from "src/img/emailCampaigns/web.svg";
import { TextInput } from "src/components";
import { capitalizeString } from "src/utils/helpers";
import { saveSettingsSocialLinks } from "../api/settingsApi";
import { LoadingIndicatorButton } from "src/scenes/Survey/components/Utils";
const socialMediaIcons = (iconName) => {
    switch (iconName) {
        case SOCIAL_MEDIAS.FACEBOOK:
            return <img src={Facebook} width="33px" height="33px" />;
        case SOCIAL_MEDIAS.INSTAGRAM:
            return <img src={Instagram} width="33px" height="33px" />;
        case SOCIAL_MEDIAS.X:
            return <img src={X} width="33px" height="33px" />;
        case SOCIAL_MEDIAS.LINKEDIN:
            return <img src={Linkedin} width="33px" height="33px" />;
        case SOCIAL_MEDIAS.YOUTUBE:
            return <img src={YouTube} width="33px" height="33px" />;
        case SOCIAL_MEDIAS.WEB:
            return <img src={Web} width="33px" height="33px" />;
        default:
            return <img src={Web} width="33px" height="33px" />;
    }
};

export default function SettingsSocialLinks(props) {
    const { settings, fetchSettings } = props;
    const [socialsHasChanges, setSocialsHasChanges] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [socialsValues, setSocialsValues] = React.useState({
        facebook: settings?.facebookUrl || "",
        instagram: settings?.instagramUrl || "",
        x: settings?.xUrl || "",
        linkedin: settings?.linkedinUrl || "",
        youTube: settings?.youTubeUrl || "",
        web: settings?.webUrl || "",
    });

    useEffect(() => {
        setSocialsValues({
            facebook: settings?.facebookUrl || "",
            instagram: settings?.instagramUrl || "",
            x: settings?.xUrl || "",
            linkedin: settings?.linkedinUrl || "",
            youTube: settings?.youTubeUrl || "",
            web: settings?.webUrl || "",
        });
    }, [settings]);

    const onSocialValueChange = (media, value) => {
        setSocialsHasChanges(true);
        setSocialsValues((prev) => ({
            ...prev,
            [media]: value,
        }));
    };

    const onCancelSenderDomainChanges = () => {
        setSocialsValues(
            {
                facebook: settings?.facebookUrl || "",
                instagram: settings?.instagramUrl || "",
                x: settings?.xUrl || "",
                linkedin: settings?.linkedinUrl || "",
                youTube: settings?.youTubeUrl || "",
                web: settings?.webUrl || "",
            }
        );
        setSocialsHasChanges(false);
    };

    const onSubmitSocialLinks = async () => {
        setIsLoading(true);
        try {
            const payload = {
                facebookUrl: socialsValues.facebook,
                instagramUrl: socialsValues.instagram,
                xUrl: socialsValues.x,
                linkedinUrl: socialsValues.linkedin,
                youTubeUrl: socialsValues.youTube,
                webUrl: socialsValues.web,
            };

            const response = await saveSettingsSocialLinks(payload);
            if (response) Toast.success("Social links have been successfully updated.");
            setSocialsHasChanges(false);
            fetchSettings();
        } catch (error) {
            console.log(error);
            Toast.error(error.getApiErrorDetails().message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <FlexContainer style={{ padding: "2rem 2rem 10px 2rem" }}>
            <TextLabel fontSize="16px" fontWeight="bold">
                Social Links (Optional)
            </TextLabel>
            <TextLabel fontSize="15px" fontWeight="normal" color="#612684">
                Add links for the following platforms to display in the email footer:
            </TextLabel>
            <FlexContainer gap="14px" margin="5px 0px 0px 0px">
                {Object.values(SOCIAL_MEDIAS).map((media, index) => {
                    return (
                        <div
                            key={index}
                            style={{
                                display: "flex",
                                gap: "10.65px",
                                flexDirection: "row",
                                alignItems: "center",
                                height: "auto",
                            }}
                        >
                            {socialMediaIcons(media)}
                            <TextInput
                                borderRadius="10px"
                                size="15px"
                                height="50px"
                                border={"1px solid #D8DEEC"}
                                backgroundColor={"#FFFFFF 0% 0% no-repeat padding-box"}
                                boxShadow="0px 3px 6px #00000029"
                                opacity="1"
                                align="left"
                                width="100%"
                                type="text"
                                placeholder={`Enter ${capitalizeString(media)} URL`}
                                placeholderColor="#808080"
                                onChange={(e) => onSocialValueChange(media, e.target.value)}
                                showErrors={true}
                                maxLength="100"
                                value={socialsValues[media]}
                                name="categoryName"
                                maxWidth="599px"
                                margin="0px"
                            />
                        </div>
                    );
                })}
            </FlexContainer>
            {socialsHasChanges && (
                <FlexContainer
                    direction="row"
                    tDirection="row"
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    maxWidth="643px"
                    gap="20px"
                    marginTop="20px"
                >
                    <ActionButton
                        height="39px"
                        width="112px"
                        border="1px solid #D8DEEC"
                        backgroundColor="#FFFFFF"
                        onClick={onCancelSenderDomainChanges}
                        disabled={isLoading}
                    >
                        Cancel
                    </ActionButton>
                    {isLoading ? (
                        <LoadingIndicatorButton height="39px" width="112px">
                            <LottieLoadingIndicator
                                height="2rem"
                                width="2rem"
                                margin="5px"
                                containerHeight="2rem"
                            />
                        </LoadingIndicatorButton>
                    ) : (
                        <ActionButton
                            height="39px"
                            width="112px"
                            border="1px solid #171A22"
                            color="#FFFFFF"
                            onClick={onSubmitSocialLinks}
                        >
                            Save
                        </ActionButton>
                    )}
                </FlexContainer>
            )}
        </FlexContainer>
    );
}
